import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 14.2136L11.4329 13.8237L11.4309 13.8223L11.4269 13.8195L11.4147 13.811L11.3736 13.7819C11.3392 13.7573 11.2907 13.7222 11.2304 13.6772C11.1097 13.5872 10.9408 13.4572 10.7395 13.2916C10.3386 12.9616 9.80183 12.4839 9.26196 11.8934C8.2179 10.7514 7 9.01215 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.01233 15.7821 10.7515 14.738 11.8935C14.1981 12.484 13.6614 12.9617 13.2604 13.2917C13.0592 13.4573 12.8902 13.5873 12.7696 13.6772C12.7092 13.7222 12.6608 13.7573 12.6263 13.7819L12.5853 13.811L12.573 13.8196L12.569 13.8223L12.5676 13.8233L12 14.2136ZM13.5 7C13.5 6.17157 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5C12.8284 8.5 13.5 7.82843 13.5 7Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 10H2V22H22V10H18V12H20V12.3397L19.8963 12.2028L19.2166 12.7175L20 13.752V20H4V14.174L5.23443 13.4187L4.36641 12H5V10ZM4.31719 12L4 12.1941V12H4.31719Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.7752 16.2789L18.6538 15.8013L17.6985 14.0442L16.8199 14.5218C16.4518 14.722 16.0714 14.8988 15.6811 15.0512L16.4087 16.9142C16.8771 16.7313 17.3335 16.5191 17.7752 16.2789Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.98978 16.0979C6.42397 16.3515 6.87366 16.5775 7.33621 16.7747L8.25611 17.1669L9.04041 15.3271L8.12051 14.9349C7.73506 14.7706 7.36032 14.5822 6.9985 14.3709L5.98978 16.0979Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.6401 17.7218L13.6388 17.672L13.5392 15.6745L12.5404 15.7243C12.1219 15.7451 11.7026 15.7397 11.2847 15.708L11.1332 17.7022C11.6346 17.7403 12.1379 17.7468 12.6401 17.7218Z"}}]};

const MapRoutePlanningFilled = Vue.extend<IconProps>({
  name: 'MapRoutePlanningFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-route-planning-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapRoutePlanningFilled;
